import { render, staticRenderFns } from "./DataConsentPage.vue?vue&type=template&id=0cc484f5&scoped=true&"
import script from "./DataConsentPage.vue?vue&type=script&lang=js&"
export * from "./DataConsentPage.vue?vue&type=script&lang=js&"
import style0 from "./DataConsentPage.vue?vue&type=style&index=0&id=0cc484f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc484f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc484f5')) {
      api.createRecord('0cc484f5', component.options)
    } else {
      api.reload('0cc484f5', component.options)
    }
    module.hot.accept("./DataConsentPage.vue?vue&type=template&id=0cc484f5&scoped=true&", function () {
      api.rerender('0cc484f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DataConsentPage.vue"
export default component.exports